import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 75106002-9EFE-4771-8B68-C60B60589C42
 * name label-variant-outline
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/label-variant-outline.svg
 * tags
 */
export const LabelVariantOutlineIcon = createSvgIcon(<><path d="M6.5,17H15L18.5,12L15,7H6.5L10,12L6.5,17M15,19H3L7.5,12L3,5H15C15.69,5 16.23,5.3 16.64,5.86L21,12L16.64,18.14C16.23,18.7 15.69,19 15,19Z" /></>, 'LabelVariantOutlineIcon');
export default LabelVariantOutlineIcon